import {
    IconDollarSignComponent,
    IconBriefcaseComponent,
    IconDocumentComponent,
    IconHomeComponent,
    IconUserComponent,
} from '@sukna/shared';
export interface INavMenu {
    link: string;
    icon: any;
    label: string;
    isDropdown: boolean;
    permission: string;
    submenu?: Array<{
        label: string;
        link: string;
        permission: string;
    }>;
}
 
export const navMenuList: Array<INavMenu> = [
    {
        link: '/dashboard',
        icon: IconHomeComponent,
        label: 'dashboard',
        isDropdown: false,
        permission: "allowed"
    },
    {
        link: '/financing-requests',
        icon: IconBriefcaseComponent,
        label: 'financingRequests',
        isDropdown: false,
        permission: "allowed"
    },
    {
        link: '/facilities-loans',
        icon: IconDollarSignComponent,
        label: 'facilitiesLoans',
        isDropdown: false,
        permission: "allowed"
    },
    {
        link: '/documents',
        icon: IconDocumentComponent,
        label: 'Documents',
        isDropdown: false,
        permission: "allowed"
    },
    {
        link: '/profile',
        icon: IconUserComponent,
        label: 'myProfile',
        isDropdown: false,
        permission: "allowed"
    },
    // {
    //     link: '/borrow-management',
    //     icon: IconUsersComponent,
    //     label: 'borrowers',
    //     isDropdown: false,
    //     permission: "BORROWERS.READ"
    // },
    // {
    //     link: '/borrow-package',
    //     icon: IconBoxComponent,
    //     label: 'borrowersPackage',
    //     isDropdown: false,
    //     permission: "BORROWERS_PACKAGE.READ"
    // },
    // {
    //     link: '/reports',
    //     icon: IconBarChartComponent,
    //     label: 'reports',
    //     isDropdown: false,
    //     permission: "REPORTS.READ"
    // },
    // {
    //     link: '',
    //     icon: IconSettingsComponent,
    //     label: 'facilityConfiguration',
    //     isDropdown: true,
    //     permission: "FACILITYTYPES.READ,LOANTYPES.READ,COVENANTS.READ,CPCS.READ,TNCS.READ,SECURITYINSTRUMENTS.READ,FACILITYFIELDS.READ",
    //     submenu: [
    //         { label: 'facilityProduct', link: '/lms-configuration/product-setup', permission: "PRODUCTS.READ" },
    //         { label: 'loanType', link: '/lms-configuration/loan-type-setup', permission: "LOANTYPES.READ" },
    //         { label: 'facilityType', link: '/lms-configuration/facility-type-setup', permission: "FACILITYTYPES.READ" },
    //         { label: 'facilityFieldsCatalog', link: '/lms-configuration/facility-fields-catalog', permission: "FACILITYFIELDS.READ" },
    //         { label: 'covenantCatalog', link: '/lms-configuration/covenant-catalog', permission: "COVENANTS.READ" },
    //         { label: 'cp/csCatalog', link: '/lms-configuration/cp-cs-catalog', permission: "CPCS.READ" },
    //         { label: 't&cCatalog', link: '/lms-configuration/t-c-catalog', permission: "TNCS.READ" },
    //         { label: 'securityCatalog', link: '/lms-configuration/security-catalog', permission: "SECURITYINSTRUMENTS.READ" },
    //     ]
    // },
    // {
    //     link: '',
    //     icon: IconLockComponent,
    //     label: 'identityAndAccess',
    //     isDropdown: true,
    //     permission: "USERS.READ,ROLES.READ",
    //     submenu: [
    //         { label: 'userManagement', link: '/identity-and-access/user-management', permission: "USERS.READ" },
    //         { label: 'roleManagement', link: '/identity-and-access/role', permission: "ROLES.READ" },
    //     ]
    // },
    // {
    //     link: '/system-configuration',
    //     icon: IconServerComponent,
    //     label: 'systemConfiguration',
    //     isDropdown: false,
    //     permission: "SYSTEM_CONFIGURATION.READ"
    // }
];


export const ROUTES = {
    // Authentication Routes
    SIGN_IN: '/login',
    MFA: '/mfa',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    DASHBOARD: '/dashboard',
    FINANCING_REQUESTS: '/financing-requests',
    FACILITIES_LOANS: '/facilities-loans',
    DOCUMENTS: '/documents',
    PROFILE: '/profile',

    // Identity and Access Routes
    USER_MANAGEMENT: '/identity-and-access/user-management',
    USER_ADD: '/identity-and-access/user-management/add',
    USER_EDIT: '/identity-and-access/user-management/edit',
    USER_VIEW: '/identity-and-access/user-management/view',
    ROLE_MANAGEMENT: '/identity-and-access/role',
    ROLE_ADD: '/identity-and-access/role/add',
    ROLE_EDIT: '/identity-and-access/role/edit',
    ROLE_VIEW: '/identity-and-access/role/view',

    // Facility Configuration Routes
    PRODUCT_SETUP: '/facility-configuration/product-setup',
    PRODUCT_SETUP_CREATE: '/facility-configuration/product-setup/create',
    PRODUCT_SETUP_EDIT: '/facility-configuration/product-setup/edit',
    PRODUCT_SETUP_VIEW: '/facility-configuration/product-setup/view',
    PRODUCT_SETUP_CONFIGURE_TEMPLATE: '/facility-configuration/product-setup/configure/template',
    LOAN_TYPE_SETUP: '/facility-configuration/loan-type-setup',
    FACILITY_TYPE_SETUP: '/facility-configuration/facility-type-setup',
    FACILITY_FIELDS_CATALOG: '/facility-configuration/facility-fields-catalog',
    COVENANT_CATALOG: '/facility-configuration/covenant-catalog',
    CPCS_CATALOG: '/facility-configuration/cp-cs-catalog',
    TNCS_CATALOG: '/facility-configuration/t-c-catalog',
    SECURITY_CATALOG: '/facility-configuration/security-catalog',

    // Borrowers Management Routes
    BORROWERS_MANAGEMENT: '/borrowers-management',
    BORROWERS_PACKAGE: '/borrowers-management/package',
    BORROWERS_PACKAGE_CONFIGURE: '/borrowers-management/package/configure/configure',
    BORROWERS_PACKAGE_VIEW: '/borrowers-management/package/configure/view',
    BORROW_PACKAGE: '/borrow-package',

    // System Routes
    REPORTS: '/reports',
    SYSTEM_CONFIGURATION: '/system-configuration',
} as const;


export const reviewedByName:string = 'Sukna Capital'